import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import qs from "qs";
import VueCookie from "vue-cookie";
import router from "../../router";

Vue.use(VueCookie);
Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.prototype.qs = qs;

export default {
  state: {
    paymentMethodes: {},
    payment: {},
    paymentDetails: {},
    customerData: {},
    countries: {},
    subscriptionHistory: {},
    customerSubscriptions: {},
    subscriptionType: {},
    subscriptionTypeLoaded: false,
    subscriptionPaymentTypes: {},
    vatCheckSuccessfull: false,
    priceWithTax: null,
    emailValid: "#e7e7e7",
    firstnameValid: "#e7e7e7",
    secondnameValid: "#e7e7e7",
    companyValid: "#e7e7e7",
    streetValid: "#e7e7e7",
    houseNumberValid: "#e7e7e7",
    zipValid: "#e7e7e7",
    cityValid: "#e7e7e7",
    vatValid: "#e7e7e7",
    privacyPolicyValid: "#e7e7e700",
    termsConditionsValid: "#e7e7e700",
    paymentLoading: false,
    subscriptionDiscount: false,
    threeDS2Payment: false,
  },
  mutations: {
    assignPaymentMethodes: (state, payload) => {
      state.paymentMethodes = payload;
    },
    assignPayment: (state, payload) => {
      state.payment = payload;
    },
    assignPaymentDetails: (state, payload) => {
      state.paymentDetails = payload;
    },
    assignVatId: (state, payload) => {
      Vue.set(state.customerData, "vatId", payload);
    },
    assignVatResult: (state, payload) => {
      state.customerData.vatResult = payload;
    },
    assignEmail: (state, payload) => {
      state.customerData.email = payload;
    },
    assignFirstname: (state, payload) => {
      state.customerData.firstname = payload;
    },
    assignSecondname: (state, payload) => {
      state.customerData.secondname = payload;
    },
    assignCompany: (state, payload) => {
      state.customerData.company = payload;
    },
    assignStreet: (state, payload) => {
      state.customerData.street = payload;
    },
    assignHouseNumber: (state, payload) => {
      state.customerData.houseNumber = payload;
    },
    assignZip: (state, payload) => {
      state.customerData.zip = payload;
    },
    assignCity: (state, payload) => {
      state.customerData.city = payload;
    },
    assignPrivacyPolicy: (state, payload) => {
      state.customerData.privacyPolicy = payload;
    },
    assignTermsConditions: (state, payload) => {
      state.customerData.termsConditions = payload;
    },
    assignCountry: (state, payload) => {
      Vue.set(state.customerData, "country", payload);
    },
    assignCustomerType: (state, payload) => {
      Vue.set(state.customerData, "customerType", payload);
    },
    assignCountries: (state, payload) => {
      payload.sort((a, b) => a.country_name.localeCompare(b.country_name));
      state.countries = payload;
    },
    assignSubscriptionType: (state, payload) => {
      state.subscriptionType = payload;
    },
    assignSubscriptionTypeLoaded: (state, payload) => {
      state.subscriptionTypeLoaded = payload;
    },
    assignPaymentTypes: (state, payload) => {
      state.subscriptionPaymentTypes = payload;
    },
    assignVatCheckSuccessfull: (state, payload) => {
      state.vatCheckSuccessfull = payload;
    },
    assignEmailValid: (state, payload) => {
      state.emailValid = payload;
    },
    assignFirstnameValid: (state, payload) => {
      state.firstnameValid = payload;
    },
    assignSecondnameValid: (state, payload) => {
      state.secondnameValid = payload;
    },
    assignCompanyValid: (state, payload) => {
      state.companyValid = payload;
    },
    assignStreetValid: (state, payload) => {
      state.streetValid = payload;
    },
    assignHouseNumberValid: (state, payload) => {
      state.houseNumberValid = payload;
    },
    assignZipValid: (state, payload) => {
      state.zipValid = payload;
    },
    assignCityValid: (state, payload) => {
      state.cityValid = payload;
    },
    assignPrivacyPolicyValid: (state, payload) => {
      state.privacyPolicyValid = payload;
    },
    assignTermsConditionsValid: (state, payload) => {
      state.termsConditionsValid = payload;
    },
    assignVatValid: (state, payload) => {
      state.vatValid = payload;
    },
    assignPriceWithTax: (state, payload) => {
      state.priceWithTax = payload;
    },
    assignPriceWithoutTax: (state, payload) => {
      state.priceWithoutTax = payload;
    },
    assignPaymentLoading: (state, payload) => {
      state.paymentLoading = payload;
    },
    assignSubscriptionHistory: (state, payload) => {
      state.subscriptionHistory = payload;
    },
    assignCustomerSubscriptions: (state, payload) => {
      state.customerSubscriptions = payload;
    },
    assignDiscount: (state, payload) => {
      state.subscriptionDiscount = payload;
    },
    assignSubscriptionCustomer: (state, payload) => {
      state.customerData.customerType = payload.customer_type;
      state.customerData.email = payload.email;
      state.customerData.firstname = payload.firstname;
      state.customerData.secondname = payload.lastname;
      state.customerData.company = payload.company;
      state.customerData.street = payload.street;
      state.customerData.houseNumber = payload.house_number;
      state.customerData.zip = payload.zip;
      state.customerData.city = payload.city;
      state.customerData.country = payload.country_id;
      state.customerData.vatId = payload.vat_id;
    },
  },
  getters: {},
  actions: {
    getPaymentMethodes: ({ commit }, payload) => {
      return axios({
        method: "post",
        data: {
          action: "get_payment_methodes",
          country_code: payload.country_code,
          shopper_locale: payload.shopper_locale,
          currency: payload.currency,
          value: payload.value,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          commit("assignPaymentMethodes", response.data.payment_methodes);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getPayment: ({ dispatch, commit, state }, payload) => {
      var subscription_type_id =
        router.history.current.query.subscription_type_id;

      return axios({
        method: "post",
        data: {
          action: "get_payment",
          payment_data: payload.payment_data,
          currency: payload.currency,
          value: payload.value,
          value_without_tax: payload.value_without_tax,
          email: state.customerData.email,
          firstname: state.customerData.firstname,
          lastname: state.customerData.secondname,
          company: state.customerData.company,
          street: state.customerData.street,
          house_number: state.customerData.houseNumber,
          zip: state.customerData.zip,
          city: state.customerData.city,
          vat_id: state.customerData.vatId || null,
          customer_type: state.customerData.customerType,
          country_id: state.customerData.country,
          country_name: payload.country_name,
          checkboxes: payload.checkboxes,
          tax: payload.tax,
          discount: state.subscriptionDiscount.percentage,
          subscription_type_id: subscription_type_id,
          subscription_type_name: state.subscriptionType.name,
          subscription_type_name_german: state.subscriptionType.name_german,
          subscription_type_invoice_text: state.subscriptionType.invoice_text,
          subscription_payment_type_id: payload.paymentTypeId,
          discount_code: router.history.current.query.discount,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "PAYMENT DETAILS ARE NOT SUPPORTED") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg: "Your credit card type is not supported for this payment.",
              type: "negativ",
            });
            return false;
          }
          if (response.data.error == "PAYMENT FAILED") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "There was an error while creating your payment. Please contact support@solar-fox.com",
              type: "negativ",
            });
            return false;
          }
          if (response.data.error == "PAYMENT FAILED - ERROR CODE 1") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "There was an error while creating your payment. Please contact support@solar-fox.com (Error Code 1)",
              type: "negativ",
            });
            return false;
          }
          if (response.data.error == "COULD NOT CREATE CUSTOMER") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create customer. Please contact support@solar-fox.com",
              type: "negativ",
            });
            return false;
          }
          if (response.data.error == "COULD NOT CREATE SUBSCRIPTION") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create subscription. Please contact support@solar-fox.com",
              type: "negativ",
            });
            return false;
          }
          commit("assignPayment", response.data.payment);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    updatePayment: ({ dispatch, commit, state }, payload) => {
      if (state.customerData.vatId && state.vatCheckSuccessfull === false) {
        state.customerData.vatId = null;
      }
      return axios({
        method: "post",
        data: {
          action: "update_payment",
          payment_data: payload.payment_data,
          currency: payload.currency,
          value: payload.value,
          value_without_tax: payload.value_without_tax,
          email: state.customerData.email,
          firstname: state.customerData.firstname,
          lastname: state.customerData.secondname,
          company: state.customerData.company,
          street: state.customerData.street,
          house_number: state.customerData.houseNumber,
          zip: state.customerData.zip,
          city: state.customerData.city,
          vat_id: state.customerData.vatId || null,
          customer_type: state.customerData.customerType,
          country_id: state.customerData.country,
          country_name: payload.country_name,
          checkboxes: payload.checkboxes,
          tax: payload.tax,
          subscription_type_id: state.subscription.subscription_type_id,
          subscription_type_name: state.subscriptionType.name,
          subscription_type_name_german: state.subscriptionType.name_german,
          subscription_payment_type_id: payload.paymentTypeId,
          customer_id: router.history.current.query.customer_id,
          order_id: router.history.current.query.order_id,
          subscription_access_token:
            router.history.current.query.subscription_access_token,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "COULD NOT UPDATE SUBSCRIPTION") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create subscription. Please contact support@solar-fox.com",
              type: "negativ",
            });
            return false;
          }
          commit("assignPayment", response.data.payment);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    updatePaymentDetails: ({ dispatch, commit, state }, payload) => {
      return axios({
        method: "post",
        data: {
          action: "update_payment_details",
          payment_details_data: payload.payment_details_data,
          currency: payload.currency,
          value: payload.value,
          value_without_tax: payload.value_without_tax,
          email: state.customerData.email,
          firstname: state.customerData.firstname,
          lastname: state.customerData.secondname,
          company: state.customerData.company,
          street: state.customerData.street,
          house_number: state.customerData.houseNumber,
          zip: state.customerData.zip,
          city: state.customerData.city,
          vat_id: state.customerData.vatId || null,
          customer_type: state.customerData.customerType,
          country_id: state.customerData.country,
          country_name: payload.country_name,
          checkboxes: payload.checkboxes,
          tax: payload.tax,
          subscription_type_id: state.subscription.subscription_type_id,
          subscription_type_name: state.subscriptionType.name,
          subscription_type_name_german: state.subscriptionType.name_german,
          subscription_payment_type_id: payload.paymentTypeId,
          customer_id: router.history.current.query.customer_id,
          order_id: router.history.current.query.order_id,
          subscription_access_token:
            router.history.current.query.subscription_access_token,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "COULD NOT UPDATE SUBSCRIPTION") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create subscription. Please contact support@solar-fox.com",
              type: "negativ",
            });
            return false;
          }
          commit("assignPaymentDetails", response.data.payment_details);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getPaymentDetails: ({ dispatch, commit, state }, payload) => {
      var subscription_type_id =
        router.history.current.query.subscription_type_id;

      return axios({
        method: "post",
        data: {
          action: "get_payment_details",
          payment_details_data: payload.payment_details_data,
          value_without_tax: payload.value_without_tax,
          value: payload.value,
          email: state.customerData.email,
          firstname: state.customerData.firstname,
          lastname: state.customerData.secondname,
          company: state.customerData.company,
          street: state.customerData.street,
          house_number: state.customerData.houseNumber,
          zip: state.customerData.zip,
          city: state.customerData.city,
          vat_id: state.customerData.vatId || null,
          customer_type: state.customerData.customerType,
          country_id: state.customerData.country,
          country_name: payload.country_name,
          checkboxes: payload.checkboxes,
          tax: payload.tax,
          discount: state.subscriptionDiscount.percentage,
          subscription_type_id: subscription_type_id,
          subscription_type_name: state.subscriptionType.name,
          subscription_type_name_german: state.subscriptionType.name_german,
          subscription_payment_type_id: payload.paymentTypeId,
          discount_code: router.history.current.query.discount,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "COULD NOT CREATE CUSTOMER") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create customer. Please contact support@solar-fox.com",
              type: "negativ",
            });
            return false;
          }
          if (response.data.error == "COULD NOT CREATE SUBSCRIPTION") {
            commit("assignPaymentLoading", false);
            dispatch("changeErrorMsg", {
              msg:
                "Could not create subscription. Please contact support@solar-fox.com",
              type: "negativ",
            });
            return false;
          }
          commit("assignPaymentDetails", response.data.payment_details);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getVatValidation: ({ dispatch, commit, state }) => {
      return axios({
        method: "post",
        data: {
          action: "get_vat_validation",
          vat_id: state.customerData.vatId,
          company: state.customerData.company,
          city: state.customerData.city,
          zip: state.customerData.zip,
          street: state.customerData.street,
          house_number: state.customerData.houseNumber,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "REQUEST FAILED") {
            dispatch("changeErrorMsg", {
              msg: response.data.error_text,
              type: "negativ",
            });
            return false;
          }
          commit("assignVatResult", response.data.vat_result);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getCountries: ({ dispatch, commit }, payload) => {
      return axios({
        cancelToken: getcancelToken(payload),
        method: "post",
        data: {
          action: "get_countries",
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "COUNTRIES NOT FOUND") {
            dispatch("changeErrorMsg", {
              msg: "could not find countries",
              type: "negativ",
            });
            return false;
          }
          commit("assignCountries", response.data.countries);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getSubscriptionType: ({ dispatch, commit }, payload) => {
      return axios({
        method: "post",
        data: {
          action: "get_subscription_type",
          id: payload,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "SUBSCRIPTION TYPE NOT FOUND") {
            dispatch("changeErrorMsg", {
              msg: "could not find subscription type",
              type: "negativ",
            });
            return false;
          }
          commit("assignSubscriptionType", response.data.subscription_type);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getPaymentTypes: ({ dispatch, commit }) => {
      return axios({
        method: "post",
        data: {
          action: "get_subscription_payment_types",
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "PAYMENT TYPES NOT FOUND") {
            dispatch("changeErrorMsg", {
              msg: "could not find payment types",
              type: "negativ",
            });
            return false;
          }
          commit("assignPaymentTypes", response.data.payment_types);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getSubscriptionCustomer: ({ dispatch, commit }, payload) => {
      return axios({
        cancelToken: getcancelToken(payload),
        method: "post",
        data: {
          action: "get_subscription_customer",
          customer_id: router.history.current.query.customer_id,
          subscription_access_token:
            router.history.current.query.subscription_access_token,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "SUBSCRIPTION CUSTOMER NOT FOUND") {
            dispatch("changeErrorMsg", {
              msg: "could not find subscription customer",
              type: "negativ",
            });
            return false;
          }
          commit("assignSubscriptionCustomer", response.data.customer);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getSubscriptionHistory: ({ dispatch, commit, state }, payload) => {
      return axios({
        cancelToken: getcancelToken(payload),
        method: "post",
        data: {
          action: "get_subscription_history",
          subscription_id: state.subscription.id,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "SUBSCRIPTION HISTORY NOT FOUND") {
            dispatch("changeErrorMsg", {
              msg: "could not find subscription history",
              type: "negativ",
            });
            return false;
          }
          commit("assignSubscriptionHistory", response.data.history);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getCustomerSubscriptions: ({dispatch, commit}, payload) => {
      return axios({
        cancelToken: getcancelToken(payload),
        method: "post",
        data: {
          action: "get_customer_subscriptions",
          customer_id: router.history.current.query.customer_id,
          subscription_access_token: router.history.current.query.subscription_access_token,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
       .then((response) => {
          if (response.data.error == "SUBSCRIPTIONS NOT FOUND") {
            dispatch("changeErrorMsg", {
              msg: "could not find subscriptions",
              type: "negativ",
            });
            return false;
          }
          commit("assignCustomerSubscriptions", response.data.subscriptions);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getInvoice: ({ dispatch }, payload) => {
      return axios({
        method: "post",
        data: {
          action: "get_invoice",
          invoice_id: payload,
        },
        responseType: "blob",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "SUBSCRIPTION HISTORY NOT FOUND") {
            dispatch("changeErrorMsg", {
              msg: "could not find subscription history",
              type: "negativ",
            });
            return false;
          }
          var disposition = response.headers["content-disposition"];
          var matches = /(filename=(.*).pdf)/.exec(disposition);
          var filename =
            matches != null && matches[2] ? matches[2] + ".pdf" : "file.pdf";
          // The actual download
          var blob = new Blob([response.data], { type: "application/pdf" });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    updateCustomer: ({ dispatch, state }) => {
      return axios({
        method: "post",
        data: {
          action: "update_subscription_customer",
          customer_id: router.history.current.query.customer_id,
          subscription_id: state.subscription.id,
          subscription_access_token:
            router.history.current.query.subscription_access_token,
          email: state.customerData.email,
          firstname: state.customerData.firstname,
          lastname: state.customerData.secondname,
          company: state.customerData.company,
          street: state.customerData.street,
          house_number: state.customerData.houseNumber,
          zip: state.customerData.zip,
          city: state.customerData.city,
          vat_id: state.customerData.vatId || null,
          customer_type: state.customerData.customerType,
          country_id: state.customerData.country,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "could not change customer data") {
            dispatch("changeErrorMsg", {
              msg: "could not change customer data",
              type: "negativ",
            });
            return false;
          } else if (response.data.error == "customer has changed") {
            dispatch("changeErrorMsg", {
              msg: "subscription was moved to a new customer, the site will reload in 10 seconds. Please check the address informations again.",
              type: "neutral",
            });
            setTimeout(() => {
              let url = new URL(window.location.href);
              url.searchParams.set('customer_id', response.data.new_customer_id);
              window.location.href = url.toString();
            }, 10000);
            return true;
          } else {
            dispatch("changeErrorMsg", {
              msg: "customer information has been changed",
              type: "positiv",
            });
            return true;
          }
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    getSubscriptionDiscount: ({ commit, dispatch }) => {
      return axios({
        method: "post",
        data: {
          action: "get_subscription_discount",
          discount: router.history.current.query.discount,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "SUBSCRIPTION DISCOUNT INVALID") {
            dispatch("changeErrorMsg", {
              msg: "Your discount code is invalid.",
              type: "negativ",
            });
            router.push(
              "/checkout/?subscription_type_id=" +
                router.history.current.query.subscription_type_id
            );
            return false;
          }
          if (response.data.error == "SUBSCRIPTION DISCOUNT NOT FOUND") {
            dispatch("changeErrorMsg", {
              msg: "Your discount code does not exist.",
              type: "negativ",
            });
            router.push(
              "/checkout/?subscription_type_id=" +
                router.history.current.query.subscription_type_id
            );
            return false;
          }
          if (response.data.error == "SUBSCRIPTION DISCOUNT ALREADY IN USE") {
            dispatch("changeErrorMsg", {
              msg: "Your discount code is already in use.",
              type: "negativ",
            });
            router.push(
              "/checkout/?subscription_type_id=" +
                router.history.current.query.subscription_type_id
            );
            return false;
          }
          commit("assignDiscount", response.data.discount);
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
  },
};

function getcancelToken(payload) {
  if (typeof payload != "undefined") {
    if (typeof payload.cancelToken != "undefined") {
      if (typeof payload.cancelToken.token != "undefined") {
        return payload.cancelToken.token;
      }
    }
  }
  return null;
}
